import { useState } from "react";
import { fetchProblemList } from "../../utils/patients/fetchProblemList";
import { fetchLabourHistory } from "../../utils/patients/fetchLabourHistory";
import useProfileStore from "../../store/patient/profileStore";




const useManageLabour = () => {
    const [loading, setLoading] = useState(false);
    const [labour, setLabour] = useState([]);
    const {profile} = useProfileStore()


  const handleFetchLabourHistory = async () => {
    setLoading(true);
    try{
      const response = await fetchLabourHistory(profile?.id)
      
      setLabour(response.data);
      console.log(response.data);
      
    } catch(err) {
      console.log(err)
      window.location.href = "/pages/signin2";
      console.log("error error");
      localStorage?.setItem("user", null)

    } finally {
      setLoading(false)
    }
  };


  return {
    handleFetchLabourHistory,
    loading,
    labour
  };

}

export default useManageLabour;